import {
    IProcessingScopesContext,
    ProcessingScopesContext,
} from "@/contexts/frontend/processing-scopes/ProcessingScopesContext";
import { useContext } from "react";

export const useProcessingScopes = () => {
    const context = useContext<IProcessingScopesContext | null>(
        ProcessingScopesContext
    );
    if (!context) {
        throw new Error(
            "useProcessingScopes must be used within a ProcessingScopesProvider"
        );
    }
    return context;
};
